import { AlertMessage } from "../types/AlertMessage";
import { CurrentUser } from "../types/User";
import ApiClientFactory from "../services/ApiClientFactory";

export interface useApiClientProps {
  user: CurrentUser | undefined;
  logout: (redirectBack?: boolean) => void;
  showAlert: (message: AlertMessage) => void;
  navigateToMaintenance: () => void;
  abortController: AbortController;
}

const useApiClient = ({
  user,
  logout,
  showAlert,
  navigateToMaintenance,
  abortController,
}: useApiClientProps) => {
  return ApiClientFactory.Create(
    user,
    logout,
    showAlert,
    navigateToMaintenance,
    abortController,
  );
};

export default useApiClient;
